import { render, staticRenderFns } from "./CockpitMatryoshkaInheritanceTree.vue?vue&type=template&id=2192e355&scoped=true"
import script from "./CockpitMatryoshkaInheritanceTree.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaInheritanceTree.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaInheritanceTree.vue?vue&type=style&index=0&id=2192e355&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2192e355",
  null
  
)

export default component.exports